<template>
  <div class="modal">
    <div 
      v-on:click="close" 
      class="modal-click-outside-area"
    >
    </div>
    <div
      class="modal-content"
    >
      <div class="modal-header">
        <p class="small-header">Translation</p>
      </div>
      <div class="modal-body">
        <div class="words-wrap">
          <p class="word-description">Spanish</p>
          <p class="word-translation">{{getLookupWords.spanishWord}}</p>
        </div>
        <div class="words-wrap">
          <p class="word-description">English:</p>
          <dot-puls-loader v-if="getLookupWords.englishWord == ''"/>
          <p v-else class="word-translation">{{getLookupWords.englishWord}}</p>
        </div>
      </div>
      <div class="modal-bottom">
        <button class="close-btn" v-on:click="close">Ok</button>
      </div>
    </div>
  </div>
</template>

<script>
// import ClickOutside from 'vue-click-outside'
import dotPulsLoader from '@/components/dotPulsLoader.vue'

export default {
  name: 'wordLookUpModal',
  components: {
    dotPulsLoader
  },
  methods: {
    close: function(){
      this.$store.commit('closeLookupModal')
    },
    open: function(){
      this.$store.commit('openLookupModal')
    }
  },
  computed: {
    getLookupWords() {
      return this.$store.getters.getLookupWords
    }
  },
  mounted () {
    // prevent click outside event with popupItem.
    // this.popupItem = this.$el
  }
  // directives: {
  //   ClickOutside
  // }
}
</script>

<style scoped>
  .modal-click-outside-area {
    cursor: pointer;
    position: absolute;
    display: block;
    content: " ";
    height: 100vh;
    width: 100%;
    top: 0;
  }
  .small-header {
    font-weight: bold;
    font-size: 20px;
    margin-top: 0px;
    border-bottom: 1px solid whitesmoke;
    padding: 0 0 17px 0;
  }
  .modal-body {
    margin-top: 27px; 
  }
  .modal-bottom {
    margin-top: 16px;
    padding-top: 20px;
    border-top: 1px solid whitesmoke;
  }
  .words-wrap{
    font-size: 20px;
  }
  .word-translation, .word-description {
    margin: 0 0 15px 0;
  }
  .word-translation {
    font-weight: bold;
    margin-left:10px;
  }
  .words-wrap {
    display: flex;

  }
  .modal {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 99; /* Sit on top */
    padding-top: 120px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }
  .modal-content {
    position: relative;
    border-radius: 4px;
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    width: 80%;
    max-width: 310px;
  }
  .close-btn {
    padding: 5px 0;
    font-size: 20px;
    border: none;
    cursor: pointer;
    font-weight: bold;
    /* font-size: 1.4rem; */
    color: white;
    border-radius: 4px;
    /* height: 40px;
    line-height: 40px; */
    background-color: #00BAE0;
    margin: 0 auto;
    width: 80px;
  }

  @media screen and (max-width: 768px) {
   .modal {
    cursor: pointer; 
  }
}
</style>